export default {
  manage_deletedKeyFob: "Llavero fue eliminado exitosamente",
  manage_deletedKeyFobs: "Llaveros fueron eliminados exitosamente",
  manage_deleteManageKeyFob_confirmationMessage:
    "¿Está seguro de que desea eliminar los siguientes Llaveros?",
  manage_deleteManageKeyFob_deleteKeyFob: "Eliminar Llavero",
  manage_deleteManageKeyFob_deleteKeyFobs: "Eliminar Llaveros",
};
